import Messagebus from 'message-bus-client'

import { getStackId } from '@app/adapters/silverfin'
import debugLog from '@app/utils/debug-log'

// eslint-disable-next-line @typescript-eslint/ban-types
export default class Polling<RF extends Function> {
  channel: string
  lastMessagebusId: number
  returnFunction: RF | (() => void)

  constructor(
    channel: string,
    lastMessagebusId: number,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    returnFunction: RF | (() => void) = (): void => {}
  ) {
    const stackId = getStackId()

    if (stackId) {
      Messagebus.baseUrl = `/stacks/${stackId}/`
    } else {
      const errMessage =
        'Polling: No stackId found. Polling will not work without a stackId.'

      debugLog(errMessage)

      if (window.Sentry) {
        window.Sentry.captureMessage(errMessage, {
          level: 'error',
          extra: {
            companyId: window.Silverfin.currentCompanyId,
            channel,
            firmId: window.Silverfin.currentFirmId,
            lastMessagebusId,
          },
        })
      }
    }

    this.channel = channel
    this.lastMessagebusId = lastMessagebusId
    this.returnFunction = returnFunction
  }

  subscribe(): void {
    Messagebus.subscribe(
      this.channel,
      this.returnFunction,
      this.lastMessagebusId
    )
  }

  unsubscribe(): void {
    Messagebus.unsubscribe(this.channel, this.returnFunction)
  }
}
